import api from '../helpers';

export default {
  get: {
    key: 'fetchCompressors',
    query: (companyId) => {
      return api.get(`/api/compressors/${companyId}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    },
    mapper: ({ data }) => {
      return data.map((model) => model);
    },
  },
  getTemplates: {
    key: 'fetchCompressorTemplates',
    query: (params = {}) => {
      const { page = 1, limit = 50, query = '' } = params;
      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(query && { query }),
      });

      return api.get(`/api/compressor-lookups?${queryParams}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    },
    mapper: ({ data }) => {
      return {
        templates: data.compressorLookups || [],
        total: data.total || 0,
        page: data.page || 1,
        totalPages: data.totalPages || 1,
      };
    },
  },
  create: {
    key: 'addCompressor',
    query: (data) => {
      return api.post('/api/compressor', {
        headers: {
          'Content-Type': 'application/json',
        },
        data,
      });
    },
  },
  edit: {
    key: 'editCompressor',
    query: (id, data) => {
      return api.put(`/api/compressor/${id}`, {
        headers: {
          'Content-Type': 'application/json',
        },
        data,
      });
    },
  },
  delete: {
    key: 'deleteCompressor',
    query: (id) => {
      return api.delete(`/api/compressor/${id}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    },
  },
  getDatasheet: {
    key: 'fetchCompressorDatasheet',
    query: (id) => {
      return api.get(`/api/compressor-lookups/${id}/datasheet`, {
        headers: {
          'Content-Type': 'application/pdf',
        },
        responseType: 'blob',
      });
    },
    mapper: ({ data, headers }) => {
      return {
        data,
        headers,
      };
    },
  },
};
